import React, {useEffect, useState, useRef} from "react";
import {
    Button,
    Form,
    Col,
    Row,
    ButtonToolbar,
    Modal,
    Dropdown,
} from "react-bootstrap";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
    CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import {LayoutSplashScreen} from "../../../_metronic/layout";
import {useSelector, useDispatch} from "react-redux";
import {useHistory, useParams} from "react-router-dom";

import {
    StatusFormatter,
    columnsComplate,
    columnsUploadPDIIN,
    components,
    dateDefault,
    formLabelsTheme,
    formatDate,
    formatterHold,
    formatterStatus,
    getValueOptions,
    iconError,
    selectStyles,
    showConfirmDialog,
    showDeleteDialog,
    showDialog,
    showErrorDialog,
    showSuccessDialog,
    sizePerPageList,
    useForceUpdate,
    useStyles,
    useStylesReddit,
    useStylesSelect,
    validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import {fetchOffice, selectOffice} from "../office/officeSlice";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    toAbsoluteUrl,
    headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import {makeStyles, fade, ThemeProvider} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    MenuItem,
    Radio,
    RadioGroup,
} from "@material-ui/core";

import {fetchClient} from "../client/clientSlice";
import {selectPagination} from "../../modules/Auth";
import {
    addUploadFile,
    addUploadFilePDIIN,
    editInbound,
    editVehicle,
    editVehicleComplate,
    editVehicleCompleteInfoUpdate,
    editVehicleConfirmInfoUpdate,
    editVehicleConfrim,
    editVehicleInfoUpdate,
    fetchFileTemplate,
    fetchFileTemplateBlob,
    fetchIdInbound,
    fetchIdVehicleFind,
    fetchIdVehicleFindInfoUpdate,
    fetchVehicle,
    fetchVehicleInfoupdate,
    removeVehicle,
    removeVehicleWorkFlow,
    removeVehicleWorkFlowInfoUpdate,
    selectIdInbound,
    selectInspection,
    selectLoading,
    selectPageNo,
    selectPageSize,
    selectTotalRecord,
    selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InputNumber from "../../utility/InputNumber";
import {env} from "../../../env";
import {
    prosesUpload,
    prosesUploadCancel,
    selectReasonCode,
} from "../miscellaneous/MiscellaneousSlice";
import {
    AddUploadFilePacking,
    AddUploadFile,
    fetchIdInfoUpdate,
    selectIdInfoUpdate,
    AddUploadFileWorkflow,
} from "./infoUpdateSlice";
import {ModalColorRadio} from "./ModalColorRadio";
import {ModalModelRadio} from "./ModalModelRadio";
import {Autocomplete} from "@material-ui/lab";

function RedditTextField(props) {
    const classes = useStylesReddit();

    return (
        <TextField InputProps={{classes, disableUnderline: true}} {...props} />
    );
}

export const WorkflowInfoUpdatePage = ({
                                           active,
                                           paramFilter,
                                           setParamFilter,
                                           paramValue,
                                           setParamValue,
                                           value,
                                           setValue,
                                           formValues,
                                           setFormValues,
                                           show,
                                           setShow,
                                           showScan,
                                           setShowScan,
                                           create,
                                           setCreate,
                                       }) => {
    const classes = useStyles();
    const classesSelect = useStylesSelect();

    const dispatch = useDispatch();
    const history = useHistory();
    const loading = useSelector(selectLoading);
    const dataId = useSelector(selectIdInfoUpdate);
    const data = useSelector(selectVehicle);
    const dataReason = useSelector(selectReasonCode);
    const pageNo = useSelector(selectPageNo);
    const pageSize = useSelector(selectPageSize);
    const totalRecord = useSelector(selectTotalRecord);
    const {id} = useParams();
    const paginationSet = useSelector(selectPagination);
    const forceUpdate = useForceUpdate();

    const [status, setStatus] = useState("");
    const [force, setForce] = useState(false);
    const inputRef = useRef(null);

    const [tableData, setTableData] = useState([]);

    const [row, setRow] = useState(null);

    const [scanFrom, setScanFrom] = useState("");

    // useEffect(() => {
    //   // Reset on first load
    //   if (active === 1Zz) {
    //     setForce(true);
    //   }
    // }, [active]);

    useEffect(() => {
        const initData = data.map((item, index) => {
            return {
                ...item,
                no: index + 1,
                // list: list,
                // listColumns: listDamage,
            };
        });

        setTableData(initData);
    }, [data]);

    useEffect(() => {
        // Add number

        const pageBefore = pageSize * (pageNo - 1);
        const initData =
            tableData === null
                ? []
                : tableData.map((item, index) => {
                    return {
                        ...item,
                        no: index + 1 + pageBefore,
                    };
                });
        setTableDataVehicle(initData);
    }, [tableData, pageSize, pageNo]);
    const [tableDataVehicle, setTableDataVehicle] = useState(tableData);

    useEffect(() => {
        // Add number
        if (force === true) {
            handleSearch();
            forceUpdate();
            setParamValue("");
            setParamFilter("");
            setForce(false);
        }
    }, [force]);

    const vehiclesOptions = [
        {
            value: "vin",
            label: "VIN",
        },
        {
            value: "von",
            label: "VON",
        },
        {
            value: "master_code",
            label: "Master Code ",
        },
        {
            value: "model_code",
            label: "Model Code ",
        },
        {
            value: "color_code",
            label: "Color Code ",
        },
    ];

    const handleChangeVehicles = (e) => {
        if (e === null) {
            e = undefined;
            setParamFilter("");
        } else {
            setParamFilter(e.value);
        }
    };

    const handleSearch = async () => {
        let result;
        let params = {};

        if (value === 0) {
            result = "5614,5621";
        } else if (value === 1) {
            result = "5623";
        } else if (value === 2) {
            result = "5622";
        }
        params.infoupdate_id = id;
        params.vehicle_status = result;
        params[paramFilter] = paramValue;
        params.is_planned = "Y,N";
        params.pageNo = 1;
        params.pageSize = paginationSet;

        try {
            const response = await dispatch(fetchVehicleInfoupdate(params));
            if (response.payload.data.status === 200) {
            } else {
                showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleTableChange = async (
        type,
        {page, sizePerPage, sortField, sortOrder, data}
    ) => {
        if (type === "pagination") {
            let result;
            let params = {};
            if (value === 0) {
                result = "5614,5621";
            } else if (value === 1) {
                result = "5623";
            } else if (value === 2) {
                result = "5622";
            }
            params.infoupdate_id = id;
            params.vehicle_status = result;
            params[paramFilter] = paramValue;
            params.is_planned = "Y,N";
            params.pageNo = page;
            params.pageSize = sizePerPage;

            try {
                const response = await dispatch(fetchVehicleInfoupdate(params));
                if (response.payload.data.status === 200) {
                } else {
                    showErrorDialog(response.payload.data.message);
                }
            } catch (error) {
                showErrorDialog(error.message);
            }
        } else {
            let result;
            if (sortOrder === "asc") {
                result = data.slice().sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1;
                    } else if (b[sortField] > a[sortField]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                result = data.slice().sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1;
                    } else if (b[sortField] > a[sortField]) {
                        return 1;
                    }
                    return 0;
                });
            }
            setTableDataVehicle(result);
        }
    };

    const options = {
        page: pageNo,
        sizePerPage: pageSize,
        showTotal: true,
        totalSize: totalRecord,
        sizePerPageList: sizePerPageList,
    };

    console.log(value, "valueasd");

    const actionFormatter = (e, row, rowIndex, formatExtraData) => {
        return (
            <>
                <div>
                    {row.vehicle_status !== "5614" && (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="products-edit-tooltip">
                                    {value === 0 ? "Edit" : "View"}
                                </Tooltip>
                            }
                        >
                            <div
                                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                onClick={() => {
                                    setFormValues({
                                        ...formValues,
                                        vin: {
                                            value: row.vin,
                                            error: false,
                                            required: "Y",
                                        },
                                        von: {
                                            value: row.von,
                                            error: false,
                                            required: "N",
                                        },

                                        color_code: {
                                            value: row.color_code === null ? "" : row.color_code,
                                            error: false,
                                            required: "N",
                                        },
                                        color_name: {
                                            value: row.color_code_name,
                                            error: false,
                                            required: "N",
                                        },
                                        model_code: {
                                            value: row.model_code === null ? "" : row.model_code,
                                            error: false,
                                            required: "N",
                                        },
                                        model_name: {
                                            value: row.model_code_name,
                                            error: false,
                                            required: "N",
                                        },
                                        model_year: {
                                            value: row.model_year,
                                            error: false,
                                            required: "N",
                                        },
                                        mileage: {
                                            value: row.mileage,
                                            error: false,
                                            required: "N",
                                        },
                                        key_no: {
                                            value: row.key_no,
                                            error: false,
                                            required: "N",
                                        },
                                        engine_no: {
                                            value: row.engine_no,
                                            error: false,
                                            required: "N",
                                        },
                                        hold_code: {
                                            value: row.hold_code,
                                            error: false,
                                            required: "N",
                                        },
                                        hold_reason: {
                                            value: row.hold_reason_remarks,
                                            error: false,
                                            required: "N",
                                        },
                                        inbound_rule: {
                                            value: row.inbound_rule,
                                            error: false,
                                            required: "N",
                                        },
                                        hold_status: {
                                            value: row.hold_status,
                                            error: false,
                                            required: "Y",
                                        },
                                        updated_date: {
                                            value: row.updated_date,
                                            error: false,
                                            required: "N",
                                        },
                                    });
                                    setRow(row);

                                    setCreate(false);

                                    setShow(true);
                                }}
                            >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  {value === 0 ? (
                      <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}/>
                  ) : (
                      <SVG
                          src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}
                      />
                  )}
                </span>
                            </div>
                        </OverlayTrigger>
                    )}

                    {row.vehicle_status === "5621" && (
                        <>
                            {value !== 1 && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                                    }
                                >
                                    <div
                                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                        onClick={(e) => handleDelete(e, row)}
                                    >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                          src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                                    </div>
                                </OverlayTrigger>
                            )}
                        </>
                    )}
                </div>
            </>
        );
    };

    const columns = [
        {
            text: "VIN",
            dataField: "vin",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
        },
        {
            text: "VON",
            dataField: "von",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
        },
        {
            text: "Master Code",
            dataField: "master_code_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Model Code",
            dataField: "model_code_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Model Name",
            dataField: "model_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Color Code",
            dataField: "color_code_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Color Name",
            dataField: "color_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Model Year",
            dataField: "model_year",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Require Acc. Installation",
            dataField: "inbound_rule",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
            formatter: formatterStatus,
        },
        {
            text: "Engine No.",
            dataField: "engine_no",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },
        {
            text: "Key No.",
            dataField: "key_no",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },

        {
            text: "Mileage",
            dataField: "mileage",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
        },

        {
            text: "Hold Status",
            dataField: "hold_status",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "130px"},
            formatter: formatterHold,
        },
        {
            text: "Hold Reason",
            dataField: "hold_code_name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "60px"},
        },
        {
            text: "Hold Remark",
            dataField: "hold_reason_remarks",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "60px"},
        },
        {
            text: "Information Update Date",
            dataField: "updated_date",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            headerAlign: "center",
            style: {minWidth: "60px"},
            formatter: formatDate
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: actionFormatter,
            align: "center",
            headerAlign: "center",
            style: {minWidth: "150px"},
        },
    ];

    const handleClose = () => {
        setShow(false);
        setFormValues({
            vin: {
                value: "",
                error: false,
                required: "Y",
            },
            von: {
                value: "",
                error: false,
                required: "N",
            },
            remarks: {
                value: "",
                error: false,
                required: "N",
            },
            from_location: {
                value: "",
                error: false,
                required: "N",
            },
            color_code: {
                value: "",
                error: false,
                required: "N",
            },
            color_name: {
                value: "",
                error: false,
                required: "N",
            },
            model_code: {
                value: "",
                error: false,
                required: "N",
            },
            model_name: {
                value: "",
                error: false,
                required: "N",
            },
            model_year: {
                value: "",
                error: false,
                required: "N",
            },
            mileage: {
                value: "",
                error: false,
                required: "N",
            },
            key_no: {
                value: "",
                error: false,
                required: "N",
            },
            engine_no: {
                value: "",
                error: false,
                required: "N",
            },
            hold_code: {
                value: "",
                error: false,
                required: "N",
            },
            hold_reason: {
                value: "",
                error: false,
                required: "N",
            },
            inbound_rule: {
                value: "",
                error: false,
                required: "N",
            },
            hold_status: {
                value: "",
                error: false,
                required: "N",
            },
            updated_date: {
                value: "",
                error: false,
                required: "N",
            },
        });

        setRow(null);
    };
    const handleCloseScan = () => {
        setScanFrom("");
        setShowScan(false);
    };

    const handleSave = async (status) => {
        if (!validatePost(formValues, setFormValues)) {
            return;
        }
        let params;

        if (create === true) {
            console.log("if");
            params = {
                infoupdate_id: id,
                vin: formValues.vin.value,
                von: formValues.von.value,
                color_code: formValues.color_code.value,
                hold_code: formValues.hold_code.value,
                hold_reason: formValues.hold_reason.value,
                key_no: formValues.key_no.value,
                engine_no: formValues.engine_no.value,
                mileage: formValues.mileage.value,
                model_code: formValues.model_code.value,
                model_year: formValues.model_year.value,
                inbound_rule: formValues.inbound_rule.value,
                hold_status: formValues.hold_status.value,
                vehicle_status: "5621",
                updated_date: formValues.updated_date.value,
            };
        } else {
            console.log("else");
            params = {
                infoupdate_id: id,
                vin: formValues.vin.value,
                von: formValues.von.value,
                color_code: formValues.color_code.value,
                hold_code: formValues.hold_code.value,
                hold_reason: formValues.hold_reason.value,
                key_no: formValues.key_no.value,
                engine_no: formValues.engine_no.value,
                mileage: formValues.mileage.value,
                model_code: formValues.model_code.value,
                model_year: formValues.model_year.value,
                inbound_rule: formValues.inbound_rule.value,
                hold_status: formValues.hold_status.value,
                // vehicle_id: row !== null ? row.vehicle_id : "",
                vehicle_status: "5621",
                updated_date: formValues.updated_date.value,
            };
        }

        console.log(params, "params");
        try {
            const response = await dispatch(editVehicleInfoUpdate(params));

            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleSearch();
                await setShow(false);
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleSaveConfrim = async () => {
        if (!validatePost(formValues, setFormValues)) {
            return;
        }

        const params = {
            infoupdate_id: id,
            vin: formValues.vin.value,
            von: formValues.von.value,
            color_code: formValues.color_code.value,
            hold_code: formValues.hold_code.value,
            hold_reason: formValues.hold_reason.value,
            key_no: formValues.key_no.value,
            engine_no: formValues.engine_no.value,
            mileage: formValues.mileage.value,
            model_code: formValues.model_code.value,
            model_year: formValues.model_year.value,
            inbound_rule: formValues.inbound_rule.value,
            hold_status: formValues.hold_status.value,
            vehicle_status: "5621",
            updated_date: formValues.updated_date.value,
        };
        console.log(params, "params");
        try {
            const response = await dispatch(editVehicleInfoUpdate(params));
            if (response.payload.status === 200) {
                const responseConfirm = await dispatch(
                    editVehicleInfoUpdate({
                        ...params,
                        vehicle_status: "5623",
                    })
                );

                if (responseConfirm.payload.status === 200) {
                    const action = await showSuccessDialog(
                        responseConfirm.payload.data.message
                    );
                    await dispatch(fetchIdInfoUpdate(id));
                    await handleClose();
                    await handleSearch();
                } else {
                    await handleClose();
                    showErrorDialog(responseConfirm.payload.data.message);
                }
            } else {
                await handleClose();

                showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            await handleClose();

            console.log(error.message);
        }
    };

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        forceUpdate();
        setForce(true);
    };

    const handleConfirm = async () => {
        const params = {
            infoupdate_id: id,
            vehicle_status: "5623",
        };

        console.log(params, "params");
        try {
            const response = await dispatch(editVehicleConfirmInfoUpdate(params));

            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleSearch();
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleComplate = async () => {
        const params = {
            infoupdate_id: id,
        };

        console.log(params, "params");
        try {
            const response = await dispatch(editVehicleCompleteInfoUpdate(params));

            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleSearch();
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleDelete = async (e, row) => {
        const params = [
            {
                vehicle_id: `${row.vehicle_id}`,
                document_id: id,
            },
        ];
        const action = await showDeleteDialog(`Are you sure you want to delete?`);
        if (action.isConfirmed) {
            try {
                const response = await dispatch(
                    removeVehicleWorkFlowInfoUpdate({data: params})
                );
                if (response.payload.data.status === 200) {
                    const action = await showSuccessDialog(response.payload.data.message);
                    await handleSearch();
                } else {
                    showErrorDialog(response.payload.data.message);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormValues({
            ...formValues,
            [name]: {
                ...formValues[name],
                value,
            },
        });
    };

    const handleModalEntered = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleFind = async () => {
        if (scanFrom === "") {
            return showDialog("Please scan or enter code");
        }
        if (scanFrom === null) {
            return showDialog("Please scan or enter code");
        }
        const params = `${scanFrom}?document_id=${id}`;
        try {
            const response = await dispatch(fetchIdVehicleFindInfoUpdate(params));

            if (response.payload.status === 200) {
                const dataId = response.payload.data.data;
                setFormValues({
                    ...formValues,
                    vin: {
                        value: dataId.vin,
                        error: false,
                        required: "Y",
                    },
                    von: {
                        value: dataId.von,
                        error: false,
                        required: "N",
                    },
                    color_code: {
                        value: dataId.color_code === null ? "" : dataId.color_code,
                        error: false,
                        required: "N",
                    },
                    color_name: {
                        value: dataId.color_code_name,
                        error: false,
                        required: "N",
                    },
                    model_code: {
                        value: dataId.model_code === null ? "" : dataId.model_code,
                        error: false,
                        required: "N",
                    },
                    model_name: {
                        value: dataId.model_code_name,
                        error: false,
                        required: "N",
                    },
                    model_year: {
                        value: dataId.model_year,
                        error: false,
                        required: "N",
                    },
                    mileage: {
                        value: dataId.mileage,
                        error: false,
                        required: "N",
                    },
                    key_no: {
                        value: dataId.key_no,
                        error: false,
                        required: "N",
                    },
                    engine_no: {
                        value: dataId.engine_no,
                        error: false,
                        required: "N",
                    },
                    hold_code: {
                        value: dataId.hold_code,
                        error: false,
                        required: "N",
                    },
                    hold_reason: {
                        value: dataId.hold_reason,
                        error: false,
                        required: "N",
                    },
                    inbound_rule: {
                        value: dataId.inbound_rule,
                        error: false,
                        required: "N",
                    },
                    hold_status: {
                        value: dataId.hold_status,
                        error: false,
                        required: "Y",
                    },
                    updated_date: {
                        value: dataId.updated_date,
                        error: false,
                        required: "N",
                    },
                });

                setShowScan(false);
                setCreate(true);
                setShow(true);
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };
    // upload file
    const [fileName, setFileName] = useState("Upload Template File");
    const [file, setFile] = useState(null);
    const [rowUpload, setRowUpload] = useState(null);
    const [showUploadView, setShowUploadView] = useState(false);

    const [showUpload, setShowUpload] = useState(false);

    const handleCloseUpload = () => {
        setShowUpload(false);
        setFile(null);
        setFileName("Upload Template File");
    };
    const handleCloseUploadView = () => {
        setShowUploadView(false);
        setRowUpload(null);
    };

    const handleUpload = async () => {
        // if (file) {
        //   return showErrorDialog("Please Input");
        // }
        const params = {
            id: id,
            file: file,
        };
        try {
            const response = await dispatch(AddUploadFileWorkflow(params));
            console.log(response, "response");
            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleCloseUpload();
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleProses = async () => {
        const params = {
            misc_header_id: rowUpload.misc_header_id,
        };
        try {
            const response = await dispatch(prosesUpload(params));

            console.log(response, "response");

            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleCloseUploadView();
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };
    const handleProsesCancel = async () => {
        const params = {
            misc_header_id: rowUpload.misc_header_id,
        };
        try {
            const response = await dispatch(prosesUploadCancel(params));

            console.log(response, "response");

            if (response.payload.status === 200) {
                const action = await showSuccessDialog(response.payload.data.message);
                await dispatch(fetchIdInfoUpdate(id));
                await handleCloseUploadView();
            } else {
                await showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };
    const handleDownload = async () => {
        const params = {
            id: id,
            type: "INFO_UPDATE_WORKFLOW",
        };
        try {
            const response = await dispatch(fetchFileTemplate(params));
            if (response.payload.status === 200) {
                const response = await dispatch(fetchFileTemplateBlob(params));
                if (response.payload.status === 200) {
                    const blob = new Blob([response.payload.data], {
                        type: "application/xlsx",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "INFO_UPDATE_WORKFLOW .xlsx";
                    link.click();
                }
            } else {
                showErrorDialog(response.payload.data.message);
                console.log("else");
            }
        } catch (error) {
            console.log("catch");
            showErrorDialog(error.message);
        }
    };

    const actionFileFormatter = (e, row, rowIndex) => {
        return (
            <div>
                <OverlayTrigger
                    overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
                >
                    <a
                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                        onClick={() => {
                            setRowUpload(row);
                            setShowUploadView(true);
                        }}
                    >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}/>
            </span>
                    </a>
                </OverlayTrigger>
            </div>
        );
    };

    const columnsFile = [
        {
            text: "Uploaded File",
            dataField: "file_name",
        },
        {
            text: "Status",
            dataField: "status",
        },
        {
            text: "Action",
            dataField: "Action",
            formatter: actionFileFormatter,
        },
    ];

    const columnsView = [
        {
            text: "VIN",
            dataField: "vin",
            sort: true,

            headerAlign: "center",
        },
        {
            text: "VON",
            dataField: "von",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Hold Remarks",
            dataField: "hold_reason_remarks",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Model Code",
            dataField: "model_code_name",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Model Year",
            dataField: "model_year",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Color Code",
            dataField: "color_code_name",
            sort: true,
            headerAlign: "center",
        },

        {
            text: "Hold Status",
            dataField: "hold_status",
            sort: true,
            headerAlign: "center",
            formatter: formatterHold,
        },
        {
            text: "Require Accessories Installation",
            dataField: "inbound_rule",
            sort: true,
            headerAlign: "center",
            formatter: formatterStatus,
        },
        {
            text: "Engine No",
            dataField: "engine_no",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Key No",
            dataField: "key_no",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Updated Date",
            dataField: "updated_date",
            sort: true,
            formatter: formatDate,
        },
        {
            text: "Validate",
            dataField: "status_validate",
            sort: true,
        },
        {
            text: "Remarks Validate",
            dataField: "remark_validate",
            sort: true,
        },
    ];

    const columnsViewComplate = [
        {
            text: "VIN",
            dataField: "vin",
            sort: true,

            headerAlign: "center",
        },
        {
            text: "VON",
            dataField: "von",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Hold Remarks",
            dataField: "hold_reason_remarks",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Model Code",
            dataField: "model_code",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Model Year",
            dataField: "model_year",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Color Code",
            dataField: "color_code",
            sort: true,
            headerAlign: "center",
        },

        {
            text: "Hold Status",
            dataField: "hold_status",
            sort: true,
            headerAlign: "center",
            formatter: formatterHold,
        },
        {
            text: "Require Accessories Installation",
            dataField: "inbound_rule",
            sort: true,
            headerAlign: "center",
            formatter: formatterStatus,
        },
        {
            text: "Engine No",
            dataField: "engine_no",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Key No",
            dataField: "key_no",
            sort: true,
            headerAlign: "center",
        },
        {
            text: "Updated Date",
            dataField: "updated_date",
            sort: true,
            formatter: formatDate,
        },
        {
            text: "Validate",
            dataField: "status_validate",
            sort: true,
        },
        {
            text: "Remarks Validate",
            dataField: "remark_validate",
            sort: true,
        },
    ];

    const [showModel, setShowModel] = useState(false);
    const [showColor, setShowColor] = useState(false);

    const [fieldsProduct, setFieldsProduct] = useState([
        {
            id: "",
            value: "",
            params: "",
            label: "",
            add: "N",
            editor: "text",
            remove: "N",
        },
    ]);
    const [getData, setGetData] = useState(false);

    const handleReasonType = (e, params) => {
        const value = params.value;
        const name = params.label;
        setFormValues({
            ...formValues,
            ["hold_code"]: {
                ...formValues["hold_code"],
                value,
            },
            ["hold_code_name"]: {
                ...formValues["hold_code_name"],
                value: name,
            },
        });
    };

    const reasonOptions = dataReason.map((e) => {
        return {
            value: e.reasoncode_id,
            label: e.reasoncode_code,
            name: e.reasoncode_name,
        };
    });

    const index = reasonOptions.findIndex(
        (obj) => obj.value === formValues.hold_code.value
    );

    const handleHoldStatus = (e) => {
        setFormValues({
            ...formValues,
            ["hold_status"]: {
                ...formValues["hold_status"],
                value: e.target.value,
            },
        });
    };
    return loading ? (
        <LayoutSplashScreen/>
    ) : (
        <>
            <Card>
                <CardBody>
                    <div className="d-flex mb-5 mt-5">
                        <div className="p-2">
                            <Button
                                className="my-btn-primary-dark "
                                onClick={(e) => setShowScan(true)}
                                disabled={
                                    dataId.process_complete === "Y" ||
                                    dataId.infoupdate_status_workflow === "COMPLETED"
                                }
                            >
                                Input Details
                            </Button>
                        </div>
                        <div className="mr-auto p-2 " onClick={(e) => setShowUpload(true)}>
                            <Button
                                className="my-btn-primary-dark "
                                disabled={
                                    dataId.process_complete === "Y" ||
                                    dataId.infoupdate_status_workflow === "COMPLETED"
                                }
                            >
                                Upload Details
                            </Button>
                        </div>
                        <div className="p-2">
                            <Button
                                variant="outline-primary"
                                onClick={handleConfirm}
                                disabled={
                                    dataId.process_complete === "Y" ||
                                    dataId.infoupdate_status_workflow === "COMPLETED"
                                }
                            >
                                Confirm
                            </Button>
                        </div>
                        <div className="p-2">
                            <Button
                                variant="primary"
                                onClick={handleComplate}
                                disabled={
                                    dataId.process_complete === "Y" ||
                                    dataId.infoupdate_status_workflow === "COMPLETED"
                                }
                            >
                                Complete
                            </Button>
                        </div>
                    </div>
                    <>
                        <Tabs
                            value={value}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            fullWidth
                        >
                            <Tab label={`Planned Vehicles`}/>
                            <Tab label={`Confirmed Vehicles`}/>
                            <Tab label={`Cancelled For Vehicles`}/>
                        </Tabs>
                        {/*  Planned Vehicles*/}
                        {value === 0 && (
                            <div className="mb-3">
                                <div className="d-flex">
                                    <div className="p-2 mt-3">Search By</div>
                                    <div className="p-2" style={{width: "180px"}}>
                                        {" "}
                                        <Select
                                            options={vehiclesOptions}
                                            value={getValueOptions(paramFilter, vehiclesOptions)}
                                            placeholder="Select"
                                            onChange={handleChangeVehicles}
                                            required
                                        />
                                    </div>
                                    <div className="p-2">
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => setParamValue(e.target.value)}
                                            value={paramValue}
                                        />
                                    </div>
                                    <div className="p-2">
                                        {" "}
                                        <Button
                                            variant="primary"
                                            onClick={(e) => {
                                                handleSearch();
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                </div>

                                {/* table */}

                                <BootstrapTable
                                    remote
                                    wrapperClasses="table-responsive"
                                    classes="table table-head-custom table-vertical-center overflow-hidden"
                                    bootstrap4
                                    keyField="vehicle_id"
                                    data={tableDataVehicle}
                                    columns={columns}
                                    pagination={paginationFactory(options)}
                                    onTableChange={handleTableChange}
                                    hover
                                >
                                    <PleaseWaitMessage entities={loading ? null : data}/>
                                    <NoRecordsFoundMessage entities={loading ? null : data}/>
                                </BootstrapTable>
                            </div>
                        )}
                        {value === 1 && (
                            <div className="mb-3">
                                <div className="d-flex">
                                    <div className="p-2 mt-3">Search By</div>
                                    <div className="p-2" style={{width: "180px"}}>
                                        {" "}
                                        <Select
                                            options={vehiclesOptions}
                                            value={getValueOptions(paramFilter, vehiclesOptions)}
                                            placeholder="Select"
                                            onChange={handleChangeVehicles}
                                            required
                                        />
                                    </div>
                                    <div className="p-2">
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => setParamValue(e.target.value)}
                                            value={paramValue}
                                        />
                                    </div>
                                    <div className="p-2">
                                        {" "}
                                        <Button
                                            variant="primary"
                                            onClick={(e) => {
                                                handleSearch();
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                </div>

                                {/* table */}

                                <BootstrapTable
                                    remote
                                    wrapperClasses="table-responsive"
                                    classes="table table-head-custom table-vertical-center overflow-hidden"
                                    bootstrap4
                                    keyField="vehicle_id"
                                    data={tableDataVehicle}
                                    columns={columns}
                                    pagination={paginationFactory(options)}
                                    onTableChange={handleTableChange}
                                    hover
                                >
                                    <PleaseWaitMessage entities={loading ? null : data}/>
                                    <NoRecordsFoundMessage entities={loading ? null : data}/>
                                </BootstrapTable>
                            </div>
                        )}
                        {value === 2 && (
                            <div className="mb-3">
                                <div className="d-flex">
                                    <div className="p-2 mt-3">Search By</div>
                                    <div className="p-2" style={{width: "180px"}}>
                                        {" "}
                                        <Select
                                            options={vehiclesOptions}
                                            value={getValueOptions(paramFilter, vehiclesOptions)}
                                            placeholder="Select"
                                            onChange={handleChangeVehicles}
                                            required
                                        />
                                    </div>
                                    <div className="p-2">
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            onChange={(e) => setParamValue(e.target.value)}
                                            value={paramValue}
                                        />
                                    </div>
                                    <div className="p-2">
                                        {" "}
                                        <Button
                                            variant="primary"
                                            onClick={(e) => {
                                                handleSearch();
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                </div>

                                {/* table */}

                                <BootstrapTable
                                    remote
                                    wrapperClasses="table-responsive"
                                    classes="table table-head-custom table-vertical-center overflow-hidden"
                                    bootstrap4
                                    keyField="vehicle_id"
                                    data={tableDataVehicle}
                                    columns={columns}
                                    pagination={paginationFactory(options)}
                                    onTableChange={handleTableChange}
                                    hover
                                >
                                    <PleaseWaitMessage entities={loading ? null : data}/>
                                    <NoRecordsFoundMessage entities={loading ? null : data}/>
                                </BootstrapTable>
                            </div>
                        )}

                        <hr/>
                        <div className="mb-3">
                            <p className="font-weight-boldest">File Upload Progress</p>
                            <Row>
                                <Col md={4}>
                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        classes="table table-head-custom table-vertical-center overflow-hidden"
                                        bootstrap4
                                        keyField="no"
                                        data={
                                            dataId.tableUploadsInfoUpdateWorkflows === null
                                                ? []
                                                : dataId.tableUploadsInfoUpdateWorkflows
                                        }
                                        columns={columnsFile}
                                        hover
                                    />
                                </Col>
                            </Row>
                        </div>
                    </>
                </CardBody>
            </Card>

            <>
                {/* Modal Inspection */}
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={show}
                    onHide={handleClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter text-white">
                            {row === null ? "Input" : "Update"} Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ThemeProvider theme={formLabelsTheme}>
                            <Row>
                                <Col xs={12} sm={3} md={6} lg={6}>
                                    <RedditTextField
                                        required
                                        label="VIN"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        size="small"
                                        fullWidth
                                        name="vin"
                                        value={formValues.vin.value}
                                        onChange={handleChange}
                                        error={formValues.vin.error}
                                        helperText={
                                            formValues.vin.error ? (
                                                <FormHelperText sx={{mt: "5px", mb: "-10px"}}>
                                                    {iconError} {"This field is required"}
                                                </FormHelperText>
                                            ) : (
                                                ""
                                            )
                                        }
                                        disabled
                                    />
                                    <TextField
                                        required
                                        id="hold_status"
                                        select
                                        label="Hold Status"
                                        defaultValue="ok"
                                        size="small"
                                        fullWidth
                                        className={classes.margin}
                                        onChange={handleHoldStatus}
                                        value={formValues.hold_status.value}
                                        error={formValues.hold_status.error}
                                        helperText={
                                            formValues.vin.error ? (
                                                <FormHelperText sx={{mt: "5px", mb: "-10px"}}>
                                                    {iconError} {"This field is required"}
                                                </FormHelperText>
                                            ) : (
                                                ""
                                            )
                                        }
                                        disabled={value === 1 ? true : false}
                                    >
                                        <MenuItem key={1} value={"Y"}>
                                            Hold
                                        </MenuItem>
                                        <MenuItem key={1} value={"N"}>
                                            Un-hold
                                        </MenuItem>
                                    </TextField>
                                    <Autocomplete
                                        disablePortal
                                        name="Hold Reason"
                                        options={reasonOptions}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        getOptionName={(option) => option.name}
                                        // disableClearable={true}
                                        // onChange={handleReasonType}
                                        value={
                                            formValues.hold_code.value != undefined ?
                                            reasonOptions.find(
                                                (option) => option.value.toUpperCase() === formValues.hold_code.value.toUpperCase()
                                            ) : null
                                        }
                                        onChange={(event, newValue) => {
                                            console.log(newValue, "newValue");
                                            if (newValue === null) {
                                                setFormValues({
                                                    ...formValues,
                                                    ["hold_code"]: {
                                                        ...formValues["hold_code"],
                                                        value: "",
                                                    },
                                                    ["hold_reason"]: {
                                                        ...formValues["hold_reason"],
                                                        value: "",
                                                    },
                                                });
                                            } else {
                                                setFormValues({
                                                    ...formValues,
                                                    ["hold_code"]: {
                                                        ...formValues["hold_code"],
                                                        value: newValue.value,
                                                    },
                                                    ["hold_reason"]: {
                                                        ...formValues["hold_reason"],
                                                        value: newValue.name,
                                                    },
                                                });
                                            }
                                        }}
                                        disabled={value === 1 ? true : false}
                                        renderInput={(params) => (
                                            <RedditTextField
                                                className={classes.margin}
                                                {...params}
                                                label="Hold Reason"
                                                id="reddit-input"
                                                size="small"
                                                fullWidth
                                                placeholder="Select"
                                                name="hold_code"
                                            />
                                        )}
                                    />

                                    <RedditTextField
                                        label="Hold Reason Remarks"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="hold_reason"
                                        value={formValues.hold_reason.value}
                                        onChange={handleChange}
                                        disabled={value === 1 ? true : false}
                                    />
                                    <RedditTextField
                                        label="Key Number"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="key_no"
                                        value={formValues.key_no.value}
                                        onChange={handleChange}
                                    />
                                    <RedditTextField
                                        label="Model Year"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="model_year"
                                        value={formValues.model_year.value}
                                        onChange={handleChange}
                                    />
                                    <RedditTextField
                                        required
                                        label="Information Update Date"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="datetime-local"
                                        size="small"
                                        fullWidth
                                        name="updated_date"
                                        value={formValues.updated_date.value}
                                        onChange={handleChange}
                                        error={formValues.updated_date.error}
                                        helperText={
                                            formValues.updated_date.error ? (
                                                <FormHelperText sx={{mt: "5px", mb: "-10px"}}>
                                                    {iconError} {"This field is required"}
                                                </FormHelperText>
                                            ) : (
                                                ""
                                            )
                                        }
                                        disabled={value === 1 ? true : false}
                                    />
                                </Col>
                                <Col xs={12} sm={3} md={6} lg={6}>
                                    <Row>
                                        <Col xs={10} sm={3} md={9} lg={9}>
                                            <RedditTextField
                                                label="Color Code"
                                                className={classes.margin}
                                                variant="filled"
                                                id="reddit-input"
                                                size="small"
                                                fullWidth
                                                value={formValues.color_name.value}
                                                disabled={dataId.infoupdate_status !== "5610"}
                                            />
                                        </Col>
                                        <Col xs={1} sm={1} md={1} lg={1}>
                                            <div>
                                                <a
                                                    className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                                                        dataId.infoupdate_status !== "5614"
                                                            ? "disabled"
                                                            : ""
                                                    }`}
                                                >
                                                    {" "}
                                                    <span
                                                        className="svg-icon svg-icon-md svg-icon-light"
                                                        onClick={() => {
                                                            setGetData(true);
                                                            setShowColor(true);
                                                        }}
                                                    >
                            <SVG
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                )}
                            />
                          </span>
                                                </a>
                                            </div>
                                        </Col>
                                        {formValues.color_code.value !== "" &&
                                            dataId.infoupdate_status === "5614" && (
                                                <div
                                                    className="ml-5"
                                                    style={{marginTop: "22px", cursor: "pointer"}}
                                                    onClick={() => {
                                                        setFormValues({
                                                            ...formValues,
                                                            ["color_code"]: {
                                                                ...formValues["color_code"],
                                                                value: "",
                                                            },

                                                            ["color_name"]: {
                                                                ...formValues["color_name"],
                                                                value: "",
                                                            },
                                                        });
                                                    }}
                                                >
                          <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                            <SVG
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/New/x-square.svg"
                                )}
                            />
                          </span>
                                                </div>
                                            )}
                                    </Row>
                                    <Row>
                                        <Col xs={10} sm={3} md={9} lg={9}>
                                            <RedditTextField
                                                label="Model Code"
                                                className={classes.margin}
                                                variant="filled"
                                                id="reddit-input"
                                                size="small"
                                                fullWidth
                                                value={formValues.model_name.value}
                                                disabled={dataId.infoupdate_status !== "5614"}
                                            />
                                        </Col>
                                        <Col xs={1} sm={1} md={1} lg={1}>
                                            <div>
                                                <a
                                                    className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                                                        dataId.infoupdate_status !== "5614"
                                                            ? "disabled"
                                                            : ""
                                                    }`}
                                                >
                          <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                  setGetData(true);
                                  setShowModel(true);
                              }}
                          >
                            <SVG
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                )}
                            />
                          </span>
                                                </a>
                                            </div>
                                        </Col>
                                        {formValues.model_code.value !== "" &&
                                            dataId.infoupdate_status === "5614" && (
                                                <div
                                                    className="ml-5"
                                                    style={{marginTop: "22px", cursor: "pointer"}}
                                                    onClick={() => {
                                                        setFormValues({
                                                            ...formValues,
                                                            ["model_code"]: {
                                                                ...formValues["model_code"],
                                                                value: "",
                                                            },
                                                            ["model_name"]: {
                                                                ...formValues["model_name"],
                                                                value: "",
                                                            },
                                                        });
                                                    }}
                                                >
                          <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                            <SVG
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/New/x-square.svg"
                                )}
                            />
                          </span>
                                                </div>
                                            )}
                                    </Row>
                                    <RedditTextField
                                        label="Mileage"
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="number"
                                        size="small"
                                        fullWidth
                                        name="mileage"
                                        value={formValues.mileage.value}
                                        onChange={handleChange}
                                        disabled={create === false && value === 1 ? true : false}
                                    />
                                    <RedditTextField
                                        label="Engine No."
                                        className={classes.margin}
                                        variant="filled"
                                        id="reddit-input"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="engine_no"
                                        value={formValues.engine_no.value}
                                        onChange={handleChange}
                                        disabled={create === false && value === 1 ? true : false}
                                    />
                                    <Form.Check
                                        inline
                                        label="Require Accessories Installation"
                                        name="inbound_rule"
                                        type="checkbox"
                                        className="ml-5 mb-4 mt-4"
                                        onChange={(e) => {
                                            if (e.target.checked === true) {
                                                setFormValues({
                                                    ...formValues,
                                                    ["inbound_rule"]: {
                                                        ...formValues["inbound_rule"],
                                                        value: "Y",
                                                    },
                                                });
                                            } else {
                                                setFormValues({
                                                    ...formValues,
                                                    ["inbound_rule"]: {
                                                        ...formValues["inbound_rule"],
                                                        value: "N",
                                                    },
                                                });
                                            }
                                        }}
                                        checked={
                                            formValues.inbound_rule.value === "Y" ? true : false
                                        }
                                        disabled={create === false && value === 1 ? true : false}
                                    />
                                </Col>
                            </Row>
                        </ThemeProvider>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        {value === 0 && (
                            <>
                                <Button variant="primary" onClick={(e) => handleSave("save")}>
                                    Save
                                </Button>

                                <Button variant="primary" onClick={handleSaveConfrim}>
                                    Confirm
                                </Button>
                            </>
                        )}
                    </Modal.Footer>
                </Modal>

                {/* scann */}
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={showScan}
                    onHide={handleCloseScan}
                    onEntered={handleModalEntered}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter text-white">
                            Scan or Enter Code
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ThemeProvider theme={formLabelsTheme}>
                            <Row>
                                <Col xs={12} sm={3} md={6} lg={6}>
                                    <Form.Control
                                        ref={inputRef}
                                        type="text"
                                        value={scanFrom}
                                        onChange={(e) => setScanFrom(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </ThemeProvider>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseScan}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleFind}>
                            Find
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* upload */}
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={showUpload}
                    onHide={handleCloseUpload}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter text-white">
                            Upload
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-5">
                            <h5 className="font-weight-boldest">File</h5>

                            <Row>
                                <Col xs={12} sm={3} md={6} lg={6}>
                                    <Form.File
                                        type="file"
                                        id="file_fpre"
                                        custom
                                        label={fileName}
                                        onChange={(e) => {
                                            setFile(e.target.files[0]);
                                            setFileName(e.target.files[0].name);
                                        }}
                                        accept=".xlsx, .XLSX"
                                    />
                                </Col>
                                <Col>
                                    <Button
                                        variant="primary"
                                        className="mr-5"
                                        onClick={handleUpload}
                                    >
                                        Upload
                                    </Button>

                                    <Button variant="outline-primary" onClick={handleDownload}>
                                        Download Template
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseUpload}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* upload View */}
                {rowUpload && (
                    <Modal
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={showUploadView}
                        onHide={handleCloseUploadView}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter text-white">
                                Upload Vehicle Information Status
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="d-flex mb-5">
                                <div class="p-2 mr-auto font-weight-boldest ">
                                    Uploaded Vehicles Data from file "{rowUpload.file_name}"
                                </div>
                                <div class="p-2 font-weight-boldest">
                                    Status :{rowUpload.status}{" "}
                                </div>
                            </div>
                            {rowUpload.status === "Uploaded" && (
                                <Row className="ml-2 mb-5">
                                    <Button
                                        variant="primary"
                                        className="mr-5"
                                        onClick={handleProses}
                                    >
                                        Process Data
                                    </Button>
                                    <Button variant="danger" onClick={handleProsesCancel}>
                                        Cancel Process Data
                                    </Button>
                                </Row>
                            )}

                            <>
                                <div
                                    className=" "
                                    style={{
                                        maxHeight: "600px",
                                        overflowY: "scroll",
                                    }}
                                >
                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        classes="table table-head-custom table-vertical-center overflow-hidden"
                                        bootstrap4
                                        keyField="no"
                                        data={rowUpload !== null ? rowUpload.data : []}
                                        columns={
                                            rowUpload.status !== "Completed"
                                                ? columnsView
                                                : columnsViewComplate
                                        }
                                        hover
                                    />
                                </div>
                            </>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseUploadView}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                <ModalModelRadio
                    isOpen={showModel}
                    setShow={setShowModel}
                    setFormValues={setFormValues}
                    formValues={formValues}
                    setFields={setFieldsProduct}
                    fields={fieldsProduct}
                    getData={getData}
                    setGetData={setGetData}
                />

                <ModalColorRadio
                    isOpen={showColor}
                    setShow={setShowColor}
                    setFormValues={setFormValues}
                    formValues={formValues}
                    setFields={setFieldsProduct}
                    fields={fieldsProduct}
                    getData={getData}
                    setGetData={setGetData}
                />
            </>
        </>
    );
};
